import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { TooltipProvider } from '@/components/ui/tooltip'
import Layout from '@/components/Layout'
import ChatVllmPage from '@/pages/Chat-vllm'
import DashboardPage from '@/pages/Dashboard'
import SettingsPage from '@/pages/Settings'
import ModelsPage from '@/pages/Models'
import TasksPage from '@/pages/Tasks'
import LogsPage from '@/pages/Logs'
import MemoryPage from '@/pages/Memory'
import AgentsPage from '@/pages/Agents'
import { useWebSocketStore } from '@/stores/websocket'
import { useEffect } from 'react'

function App() {
  const { connect, disconnect } = useWebSocketStore()

  useEffect(() => {
    connect()
    return () => disconnect()
  }, [connect, disconnect])

  return (
    <TooltipProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/chat" element={<ChatVllmPage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/memory" element={<MemoryPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/logs" element={<LogsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </Layout>
      <Toaster />
    </TooltipProvider>
  )
}

export default App
